export default __webpack_public_path__ + "static/media/conveni_M.d95cd8b3.jpg";